module.exports = __webpack_public_path__ + "img/footer-national-flag.fefb506.png";